module.exports = __webpack_public_path__ + "static/media/ResalecompanysignwsubtleGratefulDeadandLSDreference2011Enamelonboard.36e74492.webp";